<template>
  <div class="page-wrapper">
    <div class="section-title">
      <div class="left">
        <div>
          <span style="font-size: 30px">
            <svgIcon iconClass="merchants" class="icon" />
          </span>
          <span class="title-name">{{$t($route.meta.title)}}</span>
          <br />
          <span class="title-desc">{{ sortText }}</span>
        </div>
      </div>
      <div class="right">
        <div style="margin-top:15px">
          <el-button size="small" @click="onAddMerchants">新增</el-button>
          <el-button
            v-if="checkPermission(['MERCHANT_MANAGER'])"
            size="small"
            @click="onExcelExportByLoadAllData"
            :loading="exporting"
            >{{ exporting ? "正在导出" : "导出EXCEL" }}</el-button
          >
          <el-button size="small" @click="showExcelImportDialog = true"
            >EXCEL导入</el-button
          >
           <el-button
            size="small"
            @click="navToMerchantDashboard"
            v-if="
              checkPermission([
                'MERCHANT_USER',
                'MERCHANT_MINISTER',
                'MERCHANT_MANAGER',
                'MERCHANT_OBSERVER',
              ])
            "
            >漏斗图</el-button
          >
        </div>
      </div>
    </div>

    <div class="project-table-wrapper">
      <TableFilter ref="tableFilter">
        <el-row :gutter="10">
          <el-col :span="6">
            <TableFilterItem label="区域筛选:">
              <el-select
                v-model="tempArea"
                style="width: 100%"
                filterable
                clearable
                value-key="name"
                placeholder="区域来源"
                @change="areaChange"
              >
                <template v-for="(item, index) in areaGruops">
                  <el-option
                    :label="item.name"
                    :value="item"
                    :key="item.name + index"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span
                    >
                  </el-option>
                </template>
              </el-select>
            </TableFilterItem>
          </el-col>
          <el-col :span="6">
            <TableFilterItem label="姓   名:">
              <el-input
                v-model="tableFilters.name"
                placeholder="请输入姓名"
                clearable
                @input="reFresh"
              ></el-input>
            </TableFilterItem>
          </el-col>
          <el-col :span="6">
            <TableFilterItem label="电  话:">
              <el-input
                v-model="tableFilters.telephoneNo"
                placeholder="请输入电话"
                clearable
                @input="reFresh"
              ></el-input>
            </TableFilterItem>
          </el-col>
          <el-col :span="6">
            <TableFilterItem label="线索来源:">
              <el-select
                v-model="tableFilters.promotionCompanyId"
                style="width: 100%"
                filterable
                clearable
                placeholder="线索来源"
                @change="onPromotionCompanyChange"
              >
                <template v-for="(item, index) in promotionCompanies">
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    :key="item.name + index"
                  ></el-option>
                </template>
              </el-select>
            </TableFilterItem>
          </el-col>
        </el-row>
        <template #moreFilter>
          <el-row :gutter="10">
            <el-col :span="6">
              <TableFilterItem label="时间起始:">
                <el-date-picker
                  style="width: 100%"
                  v-model="tableFilters.createdAt"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="reFresh"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="跟进人:">
                <el-select
                  v-model="tableFilters.ownerId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="跟进人"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in ownersOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="跟进状态:">
                <el-select
                  v-model="tableFilters.followUpStatusId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="跟进状态"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in followUpStatusOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="线索途径:">
                <el-select
                  v-model="tableFilters.sourceId"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  placeholder="线索途径"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in sourceOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="线索阶段:">
                <el-select
                  v-model="tableFilters.stageId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="线索阶段"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in stateOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="部门:">
                <el-select
                  v-model="tableFilters.departmentId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="部门"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in departmentOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="类型：">
                <el-select
                  v-model="tableFilters.typeId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="类型"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in merchantsTypeOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
            <el-col :span="6">
              <TableFilterItem label="品牌：">
                <el-select
                  v-model="tableFilters.brandId"
                  style="width: 100%"
                  filterable
                  clearable
                  placeholder="请选择"
                  @change="reFresh"
                >
                  <template v-for="(item, index) in brandOptions">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.name + index"
                    ></el-option>
                  </template>
                </el-select>
              </TableFilterItem>
            </el-col>
          </el-row>
        </template>
      </TableFilter>
      <div class="page-table-wrapper comon-table-style">
        <el-table
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          :default-sort="{ prop: sortProp, order: listDirection }"
          @sort-change="onTableSortChange"
          border
          class="project-table"
        >
          <el-table-column
            prop="name"
            label="联系人"
            width="120"
            align="left"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="`${scope.row.name} ${scope.row.star ? '置顶' : ''}`"
              >
                <i
                  class="user-start"
                  :class="[
                    scope.row.star
                      ? 'el-icon-star-on active'
                      : 'el-icon-star-off',
                  ]"
                  @click="switchStart(scope.row)"
                ></i>
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="telephoneNo"
            label="电话"
            width="140"
            align="left"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="scope.row.telephoneNo"
                v-if="scope.row.repeatedTelephoneNo"
              >
                <el-popover placement="right" width="500" trigger="click">
                  <!-- 这里将会有表格数据 -->
                  <userReapetTable :userPhone="scope.row.telephoneNo" />
                  <i
                    class="el-icon-connection text-primary"
                    slot="reference"
                  ></i>
                </el-popover>
                {{ scope.row.telephoneNo }}
              </span>
              <span
                class="text-split"
                :title="scope.row.telephoneNo"
                v-if="!scope.row.repeatedTelephoneNo"
                >{{ scope.row.telephoneNo }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="公司名称"
            width="120"
            align="left"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.companyName">{{
                scope.row.companyName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="类型"
            align="left"
            width="80"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.typeName">{{
                scope.row.typeName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newBrandName"
            label="品牌"
            align="left"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.newBrandName">{{
                scope.row.newBrandName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sourceName"
            align="left"
            label="途经"
            width="80"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.sourceName">{{
                scope.row.sourceName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="city"
            align="left"
            label="城市"
            width="100"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="scope.row.province + scope.row.city"
              >
                <span v-if="scope.row.province != ''">{{
                  scope.row.province
                }}</span>
                <span v-if="scope.row.city != ''">{{ scope.row.city }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="promotionCompanyName"
            align="left"
            label="线索来源"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="scope.row.promotionCompanyName"
                >{{
                  scope.row.promotionCompanyName !== ""
                    ? scope.row.promotionCompanyName
                    : "暂无"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="ownerName"
            align="left"
            label="跟进人"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.ownerName">{{
                scope.row.ownerName !== "" ? scope.row.ownerName : "暂无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="followUpStatusName"
            align="left"
            label="跟进状态"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.followUpStatusName">{{
                scope.row.followUpStatusName !== ""
                  ? scope.row.followUpStatusName
                  : "暂无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastFollowUpAt"
            align="left"
            label="最后跟进时间"
            width="140"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="
                  format(new Date(scope.row.lastFollowUpAt), 'YYYY-MM-DD')
                "
                >{{ scope.row.lastFollowUpAt | date }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            align="left"
            label="创建时间"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span
                class="text-split"
                :title="format(new Date(scope.row.createdAt), 'YYYY-MM-DD')"
                >{{ scope.row.createdAt | date }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="stageName"
            align="left"
            label="阶段"
            min-width="100"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.stageName">{{
                scope.row.stageName !== "" ? scope.row.stageName : "暂无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="departmentName"
            align="left"
            label="部门"
            width="140"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="text-split" :title="scope.row.departmentName">{{
                scope.row.departmentName !== ""
                  ? scope.row.departmentName
                  : "暂无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="control"
            align="center"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- <el-button type="primary" class="edit-btn"  size="small" @click="editProject(scope.row)">编辑</el-button> -->
              <el-button
                type="warning"
                class="control-btn"
                size="small"
                @click="showMerchantsDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation-wrapper">
          <el-pagination
            class="pagenation"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSizes"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="新增-自主开发"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <MerchantsForm :isSelfDevelop="true" @onSuccess="handleFromSubmitSuccess" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="EXCEL导入"
      :visible.sync="showExcelImportDialog"
      :close-on-click-modal="false"
      width="80%"
    >
      <ImportByExcel :isSelfDevelop="true" @cancel="onExcelImportCancel" />
    </el-dialog>
  </div>
</template>

<script>
import MerchantsForm from "./components/form";
import { parseTime } from "@/utils/app";
import MiniAppQrCode from "@/components/MiniAppQrCode";
import userReapetTable from "./components/UserReapetTable";
import ImportByExcel from "./components/ImportByExcel";
import { checkPermission } from "@/utils/auth";
import TableFilter from "@/components/TableFilter";
import TableFilterItem from "@/components/TableFilterItem";
import { format } from "date-fns";
import { getOrderNameCn, getOrderType } from "@/utils/app";
import {
  GetMerchantsList,
  GetMerchantsListFilter,
  GetFollowUpStatuses,
  GetStates,
  GetMerchantsSources,
  GetMerchantsQrCode,
  PutMerchantsStarSwitch,
  GetMerchantsType,
  GetBrandsSelection
} from "./api";
export default {
  name: "merchantSelftList",
  components: {
    TableFilter,
    TableFilterItem,
    MerchantsForm,
    MiniAppQrCode,
    userReapetTable,
    ImportByExcel,
  },
  data() {
    return {
      exporting: false,
      dialogVisible: false,
      tableLoading: false,
      showAdvancedFilter: false,
      showExcelImportDialog: false,
      size: 10,
      page: 0,
      totalPages: 0,
      totalSizes: 0,
      sortedBy: null,
      sortText: `按照默认 创建时间 倒序排序`,
      sortProp: "createdAt",
      listDirection: "descending",
      tableData: [],
      tempArea: "",
      tableFilters: {
        name: "",
        telephoneNo: "",
        province: "",
        city: "",
        promotionCompanyId: "",
        createdAt: null,
        ownerId: null,
        sourceId: null,
        followUpStatusId: null,
        stageId: null,
        departmentId: null,
        brandId: null,
      },
      promotionCompanies: [],
      departmentOptions: [],
      ownersOptions: [],
      followUpStatusOptions: [],
      sourceOptions: [],
      merchantsTypeOptions:[],
      brandOptions:[],
      stateOptions: [],
      areaGruops: [],
      qrCodeLoading: false,
      defaultQrCode: "",
    };
  },
  created() {
    this.sortedBy = `${this.sortProp},${getOrderType(this.listDirection)}`;
    this.getTableData();
    this.getFilterOptions();
    this.getDefaultQrCode();
    this.getFollowUpStatuses();
    this.getMerchantsSources();
    this.getStatesOptions();
    this.getMerchantsTypeOptions();
    this.getBrandOptions();
  },
  watch: {
    $route: {
      handler(val) {
        this.setUpInsideParams();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    format,
    checkPermission,
    getOrderNameCn,
    getOrderType,
    handleSizeChange(size) {
      this.page = 0;
      this.size = size ? size : this.size;
      this.getTableData();
    },
    handleCurrentChange(Cpage) {
      this.page = Cpage ? Cpage - 1 : 0;
      this.getTableData();
    },
    // 统一处理从外部传进来的参数
    setUpInsideParams() {
      if (this.$route.params.stageId) {
        this.tableFilters.stageId = Number(this.$route.params.stageId);
      }
      if (this.$route.params.ownerId) {
        this.tableFilters.ownerId = this.$route.params.ownerId;
      }
      if (this.$route.params.departmentId) {
        this.tableFilters.departmentId = this.$route.params.departmentId;
      }
      if (this.$route.params.sourceId) {
        this.tableFilters.sourceId = this.$route.params.sourceId;
      }
      if (
        this.$route.params.createdAt &&
        this.$route.params.createdAt.length > 0
      ) {
        let createdAt = this.$route.params.createdAt;
        this.tableFilters.createdAt = createdAt.map((item) =>
          new Date(item).toISOString()
        );
      }
      this.getTableData();
      this.$nextTick(() => {
        this.$refs["tableFilter"].toggleFilter(true);
      });
    },
    filterOptionParam() {
      return {
        size: this.size,
        page: this.page,
        sort: this.sortedBy,
        name: this.tableFilters.name,
        createdAt: this.tableFilters.createdAt,
        ownerId: this.tableFilters.ownerId,
        followUpStatusId: this.tableFilters.followUpStatusId,
        telephoneNo: this.tableFilters.telephoneNo,
        province: this.tableFilters.province,
        city: this.tableFilters.city,
        promotionCompanyId: this.tableFilters.promotionCompanyId,
        sourceId: this.tableFilters.sourceId,
        stageId: this.tableFilters.stageId,
        typeId: this.tableFilters.typeId,
        departmentId: this.tableFilters.departmentId,
        brandId: this.tableFilters.brandId,
        selfDevelop: true
      };
    },
    onTableSortChange({ column, prop, order }) {
      if (order === null) {
        this.sortProp = "createdAt";
        this.listDirection = "descending";
      } else {
        this.sortProp = prop;
        this.listDirection = order;
      }
      this.sortedBy = `${this.sortProp},${getOrderType(this.listDirection)}`;
      this.sortText = `按照 ${this.getSortName(
        this.sortProp
      )} ${this.getOrderNameCn(this.listDirection)} 排序`;
      this.reFresh();
    },
    getSortName(prop) {
      let group = [
        {
          key: "name",
          name: "联系人",
        },
        {
          key: "telephoneNo",
          name: "电话",
        },
        {
          key: "companyName",
          name: "公司名称",
        },
        {
          key: "brandName",
          name: "品牌",
        },
        {
          key: "typeName",
          name: "类型",
        },
        {
          key: "sourceName",
          name: "途径",
        },
        {
          key: "city",
          name: "城市",
        },
        {
          key: "promotionCompanyName",
          name: "线索来源",
        },
        {
          key: "ownerName",
          name: "跟进人",
        },
        {
          key: "followUpStatusName",
          name: "跟进状态",
        },
        {
          key: "lastFollowUpAt",
          name: "最后跟进时间",
        },
        {
          key: "createdAt",
          name: "创建时间",
        },
        {
          key: "stageName",
          name: "阶段",
        },
        {
          key: "departmentName",
          name: "部门",
        },
      ];
      return group.find((item) => item.key == prop).name;
    },
    getTableData() {
      this.tableLoading = true;
      GetMerchantsList(this.filterOptionParam())
        .then((res) => {
          this.tableData = res.data.content;
          this.totalPages = res.data.totalPages;
          this.totalSizes = res.data.totalElements;
          this.tableLoading = false;
        })
        .catch((err) => {
           this.tableLoading = false;
          this.$notify.error({
            title: "数据拉取错误",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    getFilterOptions() {
      GetMerchantsListFilter(this.filterOptionParam())
        .then((res) => {
          let {
            cities,
            promotionCompanies,
            provinces,
            owners,
            departments,
          } = res.data;
          let regions = [];
          provinces.forEach((ele) => {
            regions.push({
              type: "province",
              name: ele,
            });
          });
          cities.forEach((ele) => {
            regions.push({
              type: "city",
              name: ele,
            });
          });
          this.departmentOptions = departments;
          this.promotionCompanies = promotionCompanies;
          this.ownersOptions = owners;
          this.areaGruops = regions;
        })
        .catch((err) => {
          console.error("筛选数据获取失败", err.response);
          this.$notify.error({
            title: "筛选数据获取失败",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    getFollowUpStatuses() {
      return new Promise((resolve, reject) => {
        GetFollowUpStatuses()
          .then((res) => {
            this.followUpStatusOptions = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject();
            console.error("获取跟进状态数据失败", err.response);
            this.$notify.error({
              title: "跟进状态获取失败",
              position: "bottom-right",
              duration: 1500,
              dangerouslyUseHTMLString: true,
              message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
            });
          });
      });
    },
    getBrandOptions() {
      return new Promise((resolve, reject) => {
        GetBrandsSelection()
          .then((res) => {
            this.brandOptions = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMerchantsTypeOptions() {
      return new Promise((resolve, reject) => {
        GetMerchantsType()
          .then((res) => {
            this.merchantsTypeOptions = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject();
            this.$notify.error({
              title: "招商类型获取失败",
              position: "bottom-right",
              duration: 1500,
              dangerouslyUseHTMLString: true,
              message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
            });
          });
      });
    },
    getStatesOptions() {
      return new Promise((resolve, reject) => {
        GetStates({ unPaged: true })
          .then((res) => {
            this.stateOptions = res.data.content;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
            console.error("获取阶段数据失败", err.response);
            this.$notify.error({
              title: "获取阶段数据失败",
              position: "bottom-right",
              duration: 1500,
              dangerouslyUseHTMLString: true,
              message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
            });
          });
      });
    },

    getMerchantsSources() {
      return new Promise((resolve, reject) => {
        GetMerchantsSources()
          .then((res) => {
            if (res.status === 200) {
              this.sourceOptions = res.data;
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject();
            console.error("获取招商途径数据失败", err.response);
            this.$notify.error({
              title: "招商途径获取失败",
              position: "bottom-right",
              duration: 1500,
              dangerouslyUseHTMLString: true,
              message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
            });
          });
      });
    },
    showMerchantsDetail(target) {
      this.$router.push({
        path: "/merchants/detail",
        query: {
          id: target.id,
        },
      });
    },
    navToSuorce() {
      this.$router.push({
        path: "/merchants/sources/list",
      });
    },
    navToStates() {
      this.$router.push({
        path: "/merchants/stages/list",
      });
    },
    navToMerchantDashboard() {
      this.$router.push({
        path: "/merchants/dashboard",
        query:{
          isSelfDevelop:true
        }
      });
    },
    // 区域筛选器回调
    areaChange(e) {
      if (e) {
        if (e.type === "city") {
          this.tableFilters.city = e.name;
        }
        if (e.type === "province") {
          this.tableFilters.province = e.name;
        }
      } else {
        this.tableFilters.city = "";
        this.tableFilters.province = "";
      }
      this.reFresh();
    },
    // 合作方变更
    onPromotionCompanyChange() {
      this.reFresh();
    },
    reFresh() {
      this.page = 0;
      this.getTableData();
    },
    onAddMerchants() {
      this.dialogVisible = true;
    },
    handleFromSubmitSuccess() {
      this.dialogVisible = false;
      this.page = 0;
      this.getTableData();
      this.getFilterOptions();
      this.getDefaultQrCode();
      this.getFollowUpStatuses();
      this.getMerchantsSources();
      this.getStatesOptions();
    },
    onExcelImportCancel(){
      this.showExcelImportDialog = false
      this.page = 0;
      this.getTableData();
    },
    onExcelExportByLoadAllData() {
      this.exporting = true;
      this.$api
        .get(`/merchants/all?selfDevelop=true`)
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            let sourceData = [];
            if(res.data.length <= 0){
              this.exporting = false;
              this.$message.warning("暂无可以导出的数据!")
              return false
            }
            res.data.forEach((ele) => {
              sourceData.push({
                ...ele,
                address: ele.country + ele.province + ele.city,
                promotionCompanyName:
                  ele.promotionCompanyName === ""
                    ? "暂无"
                    : ele.promotionCompanyName,
              });
            });
            import("@/vendor/Export2Excel").then((excel) => {
              const filterVal = [
                "name",
                "telephoneNo",
                "companyName",
                "typeName",
                "newBrandName",
                "sourceName",
                "address",
                "promotionCompanyName",
                "ownerName",
                "followUpStatusName",
                "createdAt",
                "lastFollowUpAt",
              ];
              const tHeader = [
                "姓名",
                "电话",
                "公司名称",
                "类型",
                "品牌",
                "途径",
                "地区",
                "合作方",
                "跟进人",
                "跟进状态",
                "创建时间",
                "最后跟进时间",
              ];
              const data = this.formatJson(filterVal, sourceData);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "线索管理",
                autoWidth: false,
                bookType: "xlsx",
              });
              this.exporting = false;
            });
          }
        })
        .catch((err) => {
          this.exporting = false;
          this.$message.error("获取excel数据失败");
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "createdAt") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    onPopoverQrCodeShowCallBack() {
      if (this.defaultQrCode === "") {
        this.getDefaultQrCode();
      }
    },
    // 获取默认的招商的小程序码
    getDefaultQrCode() {
      if (!this.checkPermission(["MERCHANT_MANAGER"])) {
        return false;
      }
      this.qrCodeLoading = true;
      // this.$api
      //   .get(`/merchants/qr_code_url`)
      GetMerchantsQrCode()
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.qrCodeLoading = false;
            this.defaultQrCode = res.data;
          }
        })
        .catch((err) => {
          this.qrCodeLoading = false;
          console.error("默认招商小程序码获取失败", err.response);
          this.$notify.error({
            title: "默认招商小程序码获取失败",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    // 设置用户星标
    switchStart(row) {
      PutMerchantsStarSwitch(row.id)
        .then(() => {
          this.$message.success("设置成功");
          this.reFresh();
        })
        .catch((err) => {
          this.$notify.error({
            title: "设置失败",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                      <p>错误类型：${err.response.data.error} </p>
                      <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.page-wrapper {
  text-align: left;
  /deep/ {
    .el-dialog__header {
      text-align: left;
    }
    .el-dialog__body {
      background-color: #f6f7f7;
    }
  }
  .limit-winth {
    width: 100%;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .table-edit-row {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    .table-edit-input {
      box-sizing: border-box;
      flex: 1;
      padding-right: 10px;
    }
    .table-edit-btn {
      flex: 50px 0 0;
    }
  }
  .project-table-wrapper {
    width: 100%;
    padding-top: 30px;
    .user-start {
      font-size: 20px;
      cursor: pointer;
      color: #909399;
      &.active {
        color: #ffe21c;
      }
    }
    .project-table {
      border: 1px solid #dbdbdb;
      text-align: right;
      .control-btn {
        color: #333;
        background-color: $theme_color;
        border-color: $theme_color;
        margin: 5px;
      }
      .edit-btn {
        color: #333;
        background-color: transparent;
        border-color: #333;
        margin: 5px;
      }
    }
    .table-search {
      position: absolute;
      right: 0;
      bottom: 2px;
      width: 50px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      text-align: center;
      color: #242424;
      border: 1px solid #929292;
      display: inline-block;
      transition: all 0.3s linear;
      &:hover {
        background-color: $theme_color;
        border: 1px solid $theme_color;
        color: #242424;
        cursor: pointer;
      }
    }
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 55px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
    /deep/ {
      // 页码列表的前后的按钮
      .el-pagination button {
        background-color: transparent;
      }
      .el-pagination button:disabled {
        background-color: transparent;
      }
      .el-pagination button:hover {
        color: #fff;
        background-color: #4c4948;
      }
      // 可选的页码列表
      .el-pager li {
        background-color: transparent;
      }
      .el-pager li:hover {
        color: #fff;
        background-color: #4c4948;
      }
      .el-pager li.active {
        color: #fff;
        background-color: #4c4948;
        cursor: default;
      }
      // 手动输入页数的输入框
      .el-pagination__editor.el-input .el-input__inner {
        background-color: transparent;
      }
      // 选择多少条每页的按钮
      .el-pagination .el-select .el-input .el-input__inner {
        background-color: transparent;
      }
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1 0 0;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
    }
    .right {
      flex: auto;
      text-align: right;
      overflow: hidden;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
    .title-desc {
      font-size: 14px;
      color: #989898;
    }
  }
}
</style>